module.exports = __webpack_public_path__ + "img/3C.6ed5bf64.png";